// Transcript API fns — carved verbatim from `src/api/scribeAPIV2.ts` and
// `src/api/scribeAPI.ts` (which now re-export from here), with the D2 family.
// Transport comes from the `@heidi/api` configured-client registry
// (ARCFE-805) — the registry hands back the app's real axios singletons (same
// interceptors, same retry/refresh state), so behaviour is byte-identical.
// The v1/v2 split dissolves here (design D5): both clients come from the
// registry, and each fn keeps its original client and request path.

import { getScribeHttpClients } from '@heidi/api/client';
import { type components } from '@heidi/schema/ml-scribe';

// Structural aliases of the app's `@/types` names (schema-derived there too).
type TranscriptResponse = components['schemas']['GenerateTranscriptResponseV2'];
type TranscriptLiveResponse = components['schemas']['GetSessionLiveTranscriptResponse'];

/** `GET /sessions/:id/transcript` (v2) — the legacy transcript read. */
export const getSessionTranscript = (sessionId: string) => {
  return getScribeHttpClients().scribeHttpV2.get<TranscriptResponse>(
    `/sessions/${sessionId}/transcript`
  );
};

/** `GET /sessions/:id/transcript/live` (v2). */
export const getLiveTranscript = (
  sessionId: string,
  status?: 'complete' | 'in_progress'
) => {
  return getScribeHttpClients().scribeHttpV2.get<TranscriptLiveResponse>(
    `/sessions/${sessionId}/transcript/live`,
    {
      params: {
        status,
      },
    }
  );
};

/** `POST /sessions/:id/transcript/backup-transcript` (v2). */
export const generateBackupTranscript = (sessionId: string) => {
  return getScribeHttpClients().scribeHttpV2.post(
    `/sessions/${sessionId}/transcript/backup-transcript`
  );
};

/** `DELETE /sessions/:id/transcript` (v1). */
export const deleteSessionTranscript = (sessionId: string) => {
  return getScribeHttpClients().scribeHttp.delete<void>(
    `/sessions/${sessionId}/transcript`
  );
};

/** `POST /sessions/:id/transcript` (v1) — upload a backup transcript. */
export const uploadBackupTranscript = (sessionId: string, transcript: string) => {
  return getScribeHttpClients().scribeHttp.post(`/sessions/${sessionId}/transcript`, {
    transcript,
  });
};
